import common from 'app/locales/en/common'
import origination from 'app/locales/en/origination'
import portal from 'app/locales/en/portal'
import prequal from 'app/locales/en/prequal'

export default {
    ...common,
    ...prequal,
    ...origination,
    ...portal
}
